// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.df-mapview {
  height: 100%;
  width: 100%;
}

.footer-info-container {
  height: 20px;
  font-size: 10px;
  color: var(--color-text-1);
  border-top: 1px solid var(--border-color-1);
  background-color: var(--background-color-1);
  overflow: hidden;
  width: 100%;
  display: flex;
  user-select: none;
  align-items: center;
  position: absolute;
  bottom: 0;
  opacity: 0.85;
}
.footer-info-content {
  width: 130px;
  color: var(--color-text-4);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 5px;
  font-size: 10px !important;
}

.footer-info-content span {
  font-weight: 600;
  color: var(--color-text-1);
}
.footer-info-container .footer-info-content:nth-child(1) {
  flex-grow: 1;
}
.footer-info-container .footer-info-content:nth-child(2) {
  width: 110px;
}

.footer-info-container .footer-info-content:nth-child(3),
.footer-info-container .footer-info-content:nth-child(4) {
  width: 105px;
}

.footer-info-content img {
  height: 100%;
  width: 47px;
  margin-left: 10px;
}



@media only screen and (max-width: 650px) {
  .footer-info-container .footer-info-content:nth-child(5),
  .footer-info-container .footer-info-content:nth-child(6) {
    display: none;
  }
}

@media only screen and (max-width: 400px) {
  .footer-info-container .footer-info-content:nth-child(1) {
    display: block;
  }

  .footer-info-container .footer-info-content {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/footerView.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,2CAA2C;EAC3C,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;;;AAIA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".df-mapview {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.footer-info-container {\r\n  height: 20px;\r\n  font-size: 10px;\r\n  color: var(--color-text-1);\r\n  border-top: 1px solid var(--border-color-1);\r\n  background-color: var(--background-color-1);\r\n  overflow: hidden;\r\n  width: 100%;\r\n  display: flex;\r\n  user-select: none;\r\n  align-items: center;\r\n  position: absolute;\r\n  bottom: 0;\r\n  opacity: 0.85;\r\n}\r\n.footer-info-content {\r\n  width: 130px;\r\n  color: var(--color-text-4);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  margin-left: 5px;\r\n  font-size: 10px !important;\r\n}\r\n\r\n.footer-info-content span {\r\n  font-weight: 600;\r\n  color: var(--color-text-1);\r\n}\r\n.footer-info-container .footer-info-content:nth-child(1) {\r\n  flex-grow: 1;\r\n}\r\n.footer-info-container .footer-info-content:nth-child(2) {\r\n  width: 110px;\r\n}\r\n\r\n.footer-info-container .footer-info-content:nth-child(3),\r\n.footer-info-container .footer-info-content:nth-child(4) {\r\n  width: 105px;\r\n}\r\n\r\n.footer-info-content img {\r\n  height: 100%;\r\n  width: 47px;\r\n  margin-left: 10px;\r\n}\r\n\r\n\r\n\r\n@media only screen and (max-width: 650px) {\r\n  .footer-info-container .footer-info-content:nth-child(5),\r\n  .footer-info-container .footer-info-content:nth-child(6) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 400px) {\r\n  .footer-info-container .footer-info-content:nth-child(1) {\r\n    display: block;\r\n  }\r\n\r\n  .footer-info-container .footer-info-content {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
